import React from 'react';
import Select, { Props as SelectProps } from 'react-select';

interface SingleSelectProps extends SelectProps {
  // Add any custom props here if needed, otherwise it just extends SelectProps
  className?: string; // Allow passing extra classes to the container
  variant?: "default" | "kra";
}

const SingleSelect: React.FC<SingleSelectProps> = ({
  className,
  variant = "default",
  ...props
}) => {
  const isKra = variant === "kra";
  return (
    <Select
      {...props}
      classNames={{
        control: (state: any) =>
          `!min-h-[30px] !text-sm !border-gray-200 !shadow-none ${isKra
            ? "hover:!border-[#01f121ff]"
            : "hover:!border-blue-500"
          } ${state.isFocused
            ? isKra
              ? "!border-[#01f121ff] !ring-0"
              : "!border-blue-500 !ring-1 !ring-blue-500"
            : ""
          }`,
        menu: () =>
          "!z-[9999] !bg-white !shadow-lg !min-w-[400px] !w-max !rounded-md !mt-1",
        menuPortal: () => "!z-[9999]",
        option: (state: any) =>
          `!text-sm !cursor-pointer !px-3 !py-2 ${state.isSelected
            ? "!bg-blue-50"
            : state.isFocused
              ? "!bg-gray-100"
              : "!bg-white"
          } !text-gray-800`,
      }}
      className={`mt-2 text-sm  ${className || ""}`}
      menuPortalTarget={document.body}
      menuPosition="fixed"
    />
  );
};

export default SingleSelect;
